// Box or piece pricing: a piece costs box price / units per box.
export const canPieces = (item) => (item?.units_per_box || 0) > 0;
export const unitPrice = (item, price, mode) => (mode === "piece" && canPieces(item) ? Math.round((price.final_net_price / item.units_per_box) * 10000) / 10000 : price.final_net_price);
// SoftOne unit names (Τεμ., Πακ., ...) → i18n keys; unknown units are shown as-is
const UNIT_KEYS = { "Τεμ.": "PCS", "Πακ.": "PACK", "Κιβ.": "BOX", "Κιλά": "KG", "Ρολό": "ROLL" };
const KNOWN = ["PCS", "ROLL", "PACK", "CAN", "BOTTLE", "SACK", "BOX", "KG", "MONTH", "M"];
export const unitName = (t, u) => { const k = UNIT_KEYS[u] || u; return KNOWN.includes(k) ? t(`unit.${k}`) : u || ""; };
export const uomLabel = (t, uom) => t(uom === "piece" ? "x.uom.piece" : "x.uom.box");
